module.exports = __webpack_public_path__ + "img/lc-active.f7421d6e.png";